import { Radio, TextField } from '@arionbanki/arionui';
import { SSNInput } from 'components';
import type { useNetbank } from './useNetbank';

export function NetbankForm(props: Readonly<ReturnType<typeof useNetbank>>) {
	const { applicantIsOnlyUser, errors, setApplicantIsOnlyUser, t } = props;
	return (
		<form>
			<p>
				<Radio
					checked={true === applicantIsOnlyUser}
					id={'true'}
					label={t('radio_one_user', 'netbank')}
					mode="primary"
					onChange={() => setApplicantIsOnlyUser(true)}
				/>
			</p>
			<p className="primary">
				<Radio
					checked={false === applicantIsOnlyUser}
					id={'false'}
					label={t('radio_multiple_users', 'netbank')}
					mode="primary"
					onChange={() => setApplicantIsOnlyUser(false)}
				/>
			</p>
			<div className={applicantIsOnlyUser ? 'd-none' : ''}>
				<p className="text-muted mt-4 mb-3">
					<strong>{t('master_user', 'netbank')}</strong>
					&nbsp;
					<small>
						<em>{t('master_user_info', 'netbank')}</em>
					</small>
				</p>
				<div className="row">
					<div className="col-md-6 col-lg-4">
						<SSNInput
							defaultValue=""
							error={!!errors.keyUserSsn}
							label={t('master_user_ssn', 'netbank')}
							name="keyUserSsn"
						/>
					</div>
					<div className="col-md-6 col-lg-4">
						<TextField
							error={!!errors.keyUserEmail}
							label={t('master_user_email', 'netbank')}
							message={t(errors.keyUserEmail, 'netbank')}
							name="keyUserEmail"
							onChange={props.validate}
						/>
					</div>
					<div className="col-md-6 col-lg-4">
						<TextField
							error={!!errors.keyUserPhone}
							label={t('master_user_phone', 'netbank')}
							message={t(errors.keyUserPhone, 'netbank')}
							name="keyUserPhone"
							onChange={props.validate}
						/>
					</div>
				</div>
				<p className="text-muted mt-4 mb-3">
					<strong>{t('supervisor', 'netbank')}</strong>{' '}
					<small>
						<em>{t('supervisor_info', 'netbank')}</em>
					</small>
				</p>
				<div className="row">
					<div className="col-md-6 col-lg-4">
						<SSNInput
							defaultValue=""
							error={!!errors.supervisorSsn}
							label={t('supervisor_ssn', 'netbank')}
							name="supervisorSsn"
						/>
					</div>
					<div className="col-md-6 col-lg-4">
						<TextField
							error={!!errors.supervisorEmail}
							label={t('supervisor_email', 'netbank')}
							message={t(errors.supervisorEmail, 'netbank')}
							name="supervisorEmail"
							onChange={props.validate}
						/>
					</div>
				</div>
			</div>
		</form>
	);
}
